<h1 mat-dialog-title>
  {{ 'map.sidebar.shape.style_form.styles_list' | translate }}
</h1>
<div mat-dialog-content>
  <div class="d-flex justify-content-end">
    <button
      mat-flat-button
      (click)="addNewLayerStyle()"
      color="primary"
      class="w-100 add-layer-btn"
      *ngIf="canAddStyle"
    >
      <span>Aggiungi stile</span>
    </button>
  </div>
  <mat-list style="max-height: 400px; overflow-y: auto">
    <mat-list-item *ngFor="let style of layerStyleOptions; let i = index">
      <div class="d-flex w-100 justify-content-between align-items-center">
        <div>
          <img style="width: 30px; height: 30px; margin-right: 5px" [src]="imageUrls[i] | async" />
          <span> {{ style.label }}</span>
        </div>
        <div>
          <button
            *ngIf="checkIfCanEdit(style)"
            type="button"
            mat-icon-button
            color="primary"
            (click)="editStyle(style.name, style)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <!-- <button *ngIf="canDeleteStyle" type="button" mat-icon-button color="primary" (click)="deleteStyle(style.name)">
                        <mat-icon>trash</mat-icon>
                    </button> -->
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
</div>
